<template>
  <router-view />

  <van-tabbar route>
    <van-tabbar-item replace to="/" icon="home-o">
      报名
    </van-tabbar-item>
    <!-- <van-tabbar-item replace to="/person" icon="search">
      我的
    </van-tabbar-item> -->
  </van-tabbar>
</template>

<script>
export default {
  name: "TabBottom",
  setup() {}
};
</script>
